"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DistributeGlobeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.98790054,4.68768031 L5.14846942,3.84506129 C4.95566591,3.65152558 4.95625948,3.33833575 5.1497952,3.14553224 C5.34345761,2.9526608 5.65670652,2.95325936 5.84957769,3.14681656 L6.68756343,3.98778295 C7.45811639,3.36972472 8.43641439,3 9.50106624,3 C11.9863476,3 14.0010662,5.01471863 14.0010662,7.5 C14.0010662,8.56381357 13.6319235,9.54140923 13.0147427,10.3116823 L13.8574133,11.1579295 C14.0498605,11.3511935 14.0491983,11.6638741 13.8559343,11.8563213 C13.6598644,12.0501879 13.3459274,12.0489463 13.1526296,11.8547774 L12.3141687,11.0125381 C11.6660075,11.5323054 10.8708972,11.8763807 10.0010662,11.9725356 L10.0010662,14 L12.0010662,14 L12.0010662,15 L7.00106624,15 L7.00106624,14 L9.00098962,14 L9.00102898,11.9725315 C6.75107169,11.7237924 5.00106624,9.81626404 5.00106624,7.5 C5.00106624,6.43589297 5.37041266,5.45805142 5.98790054,4.68768031 Z M6.00106624,7.5 C5.99391432,9.43298168 7.56807073,11 9.50106624,11 C11.3180596,11 13,9.52133778 13.0010662,7.5 C13.0020859,5.56702263 11.4340625,4 9.50106624,4 C7.5588636,4 6.00797005,5.63407219 6.00106624,7.5 Z" })));
};
DistributeGlobeSmall.displayName = 'DistributeGlobeSmall';
exports.default = DistributeGlobeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DistributeGlobeSmall.js.map